module.exports = __webpack_public_path__ + "img/chevron-left_1.00a12408.svg";